import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ZohoReportService {
    constructor(private httpClient: HttpClient) {}

    getDashboardUrl(): Observable<string> {
        return this.httpClient.get(environment.apiInboxUrl + 'ZohoReports/DashboardUrl', { responseType: 'text' });
    }
}
